import { KTSVG } from '_metronic/helpers';
import NumericComponent from 'app/components/FormComponents/NumericComponent';
import SelectComponent from 'app/components/FormComponents/SelectComponent';
import * as Yup from 'yup';
import { getPerceptionDeductions } from 'app/service/catalog/Catalogs';
import { SelectOption } from 'app/types/commons';
import { useFormik } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import { toast } from 'react-toastify';
import { PerceptionDeduction } from 'app/types/perceptions';
import {
  getCollaboratorPerceptions,
  getCollaboratorPerceptionsSettings,
  postPerceptions,
  postPerceptionsSecondRoster,
} from 'app/service/perception/perception';
import { Collaborator } from 'app/types/collaborator';
import { toaster } from 'app/utilities/commons';

type Props = {
  collaborator?: Collaborator;
  handleCloseModal?: () => void;
  fetchCollaboratorPerceptionsId: (id: number | string | undefined) => void;
  fetchCollaboratorSettings?: () => void;
  periodId: number;
};

type FormValues = {
  typePerception: SelectOption | null;
  amount?: number;
};

const initialValues: FormValues = {
  typePerception: null,
  amount: 0,
};

const PerceptionsSettings: React.FC<Props> = ({
  collaborator,
  handleCloseModal,
  fetchCollaboratorPerceptionsId,
  fetchCollaboratorSettings,
  periodId
}) => {
  const [show, setShow] = useState(false);
  const [typesPerception, setTypesPerception] = useState<PerceptionDeduction[]>(
    []
  );
  const [selectPerception, setSelectPerception] = useState<SelectOption[]>([]);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<any[]>([]);
  const [prevRows, setPrevRows] = useState<any[]>([]);

  const validationSchema = Yup.object({
    typePerception: Yup.object()
      .nullable()
      .shape({
        value: Yup.number().required('Este campo es requerido'),
        label: Yup.string(),
      })
      .required('Este campo es requerido'),
      amount: Yup.number()
      .when('typePerception', (typePerception, schema) => {
        if (Number(typePerception?.typeId) === 3) {
          
          return schema
            .min(1, 'La cantidad tiene que ser mayor que 0')
            .max(15, 'La cantidad tiene que ser menor que 16')
            .required('Este campo es requerido')
        }
        if (Number(typePerception?.typeId) === 4) {
          
          return schema
            .min(1, 'La cantidad tiene que ser mayor que 0')
            .max(999999, 'La cantidad tiene que ser menor que 1,000,000')
            .required('Este campo es requerido');
        }
        
        
        return schema.notRequired();
      })
  });
  
  
  const formData = useFormik<FormValues>({
    initialValues,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true);
      try {
        await postPerceptionsSecondRoster({
          collaboratorId: Number(collaborator!.id),
          perceptionId: values.typePerception?.value,
          value: Number(value),
          periodId: periodId,
        });
        formData.resetForm();
        fillDataAsync();
        handleCloseModal?.();
        fetchCollaboratorPerceptionsId(collaborator!.id);
        fetchCollaboratorSettings?.();
        setShow(false);
        const message = 'Se actualizó la información de percepciones con éxito';
        toaster.success(message);
      } catch (error: any) {
        console.error('error en submit', error);
      }
    },
  });
  const typePerception = useMemo(() => {
    if (formData.values.typePerception?.value && typesPerception) {
      return typesPerception.find(
        (item) => item.id === formData.values.typePerception?.value
      );
    }
    return null;
  }, [formData.values.typePerception, typesPerception]);
  
  const value = useMemo(() => {
    if (typePerception) {
      switch (typePerception.typePerceptionDeductionId) {
        case 1:
          return typePerception.value;
        case 2:
          switch (typePerception.factorBaseId) {
            case 1:
              return (
                typePerception.value * Number(collaborator!.employe?.baseSalary)
              );
            case 2:
              return (
                typePerception.value *
                Number(collaborator!.employe?.dayliSalary)
              );
            case 3:
              return (
                (typePerception.value *
                  Number(collaborator!.employe?.baseSalary)) /
                collaborator!.employe?.factor[0].value!
              );
            default:
              return (
                typePerception.value * Number(collaborator!.employe?.baseSalary)
              );
          }
        case 3:
          return (formData.values.amount ?? 0) * Number(typePerception.value);
        case 4:
        default:
          return Number(formData.values.amount ?? 0);
      }
    }
    return 0;
  }, [typePerception, formData.values.amount]);

  const fillDataAsync = async () => {
    try {
      const typesRes = await getPerceptionDeductions();
      
      const prevRes = await getCollaboratorPerceptions(collaborator!.id!).catch(
        (error) => {
          console.error('error al cargar las percepciónes anteriores', error);
        }
      );
      if (prevRes)
        setPrevRows(
          prevRes.map((item) => ({
            perception: item.perception,
            value: item.value.toLocaleString(),
          }))
        );
      setTypesPerception(typesRes.records);
      setSelectPerception(
        typesRes.records
          .filter((item) => item.typeMovementId === 1)
          .map((item) => ({
            value: item.id,
            label: item.description,
            typeId: item.typePerceptionDeductionId
          }))
      );
      console.log(typePerception)
      console.log(typesPerception)
    } catch (error) {
      console.error('error en carga de catalogos', error);
    }
  };
  useEffect(() => {
    if (collaborator) {
      fillDataAsync();
    }
  }, [collaborator]);
  return (
    <div>
      <div className=" mt-4">
        <form
          id="kt_modal_generic_form"
          className="form"
          action="#"
          onSubmit={formData.handleSubmit}
        >
          <div className="m-3">
            <SelectComponent
              options={selectPerception}
              formData={formData}
              name="typePerception"
              display={'-1'}
            />
            {formData.touched.typePerception && formData.errors.typePerception && (
              <div className="fv-plugins-message-container text-danger w-100">
                <span role="alert">{formData.errors.typePerception}</span>
              </div>
            )}
          </div>
          <div className="d-flex flex-column flex-xl-row flex-row-fluid mt-5">
            <div className="w-100 d-flex">
              <div className="w-100 pe-5">
                {typeof typePerception?.typePerceptionDeductionId ===
                  'number' && (
                  <div className="container">
                    <div className="row">
                      {[1, 2, 3].includes(
                        typePerception?.typePerceptionDeductionId
                      ) && (
                        <div className="col">
                          <h4>Valor</h4>
                          <p>
                            {typePerception?.typePerceptionDeductionId === 2
                              ? `${Math.round(typePerception.value * 100)}%`
                              : typePerception.value.toFixed(2)}
                          </p>
                        </div>
                      )}
                      {[3,4].includes(
                        typePerception?.typePerceptionDeductionId
                      ) && (
                        <div className="col">
                          <NumericComponent
                            label="Cantidad"
                            formData={formData}
                            name="amount"
                            max={100}
                            display={'-1'}
                          />
                          {formData.touched.amount && formData.errors.amount && (
                            <div className="fv-plugins-message-container text-danger w-100">
                              <span role="alert">{formData.errors.amount}</span>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div className="row">
                      <div className="col mt-5">
                        <h4>Valor Total</h4>
                        <p>{typeof value === 'number' ? value.toFixed(2) : '0.00'}</p>
                        {value > 999999 && <div className="text-danger">El valor total no puede ser mayor a 999,999</div>}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-between mt-10">
            <button
              type="reset"
              className="btn btn-light me-3"
              data-kt-users-modal-action="cancel"
              onClick={handleCloseModal}
            >
              Cerrar
            </button>
            <button type="submit" data-kt-users-modal-action="submit" className="btn btn-primary">
              Guardar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PerceptionsSettings;
